/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Tag } from 'carbon-components-react';
import cx from 'classnames';
import React from 'react';

import './PlusTag.scss';

export const strings = {
  PLUS: 'Plus'
};

export interface PlusTagProps {
  element?: string;
  className?: string;
}

/*
 * This is a common/shared component that labels Plus plan features with a consistent styling in form of a tag.
 */
const PlusTag: React.FC<PlusTagProps> = ({ element, className }) => (
  <Tag
    type="green"
    className={cx('PlusTag', {
      [`PlusTag__${element}`]: element,
      [`${className}`]: className
    })}>
    {strings.PLUS}
  </Tag>
);

PlusTag.defaultProps = {
  className: ''
};

export default PlusTag;
